import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { offlineServices } from './services/offline/index';
import { onlineServices } from './services/online/index';

@NgModule({
  imports: [CommonModule],
  providers: [...onlineServices, ...offlineServices],
})
export class CoreModule {}
